import type { LightboxState, LightboxElements } from './types';
import { MIN_ZOOM, MAX_ZOOM } from './state';

export function setZoom(state: LightboxState, elements: LightboxElements, level: number): void {
    state.zoomLevel = Math.max(MIN_ZOOM, Math.min(MAX_ZOOM, level));

    if (state.zoomLevel === 1) {
        state.translateX = 0;
        state.translateY = 0;
        state.lastTranslateX = 0;
        state.lastTranslateY = 0;
    }

    updateImageTransform(state, elements);
    updateZoomUI(state, elements);
}

export function resetZoom(state: LightboxState, elements: LightboxElements): void {
    state.zoomLevel = 1;
    state.translateX = 0;
    state.translateY = 0;
    state.lastTranslateX = 0;
    state.lastTranslateY = 0;
    elements.img.style.transform = '';
    elements.img.classList.remove('is-zoomed', 'is-dragging');
    updateZoomUI(state, elements);
}

export function updateImageTransform(state: LightboxState, elements: LightboxElements): void {
    const translateX = state.translateX / state.zoomLevel;
    const translateY = state.translateY / state.zoomLevel;
    elements.img.style.transform = `scale(${state.zoomLevel}) translate(${translateX}px, ${translateY}px)`;
    elements.img.classList.toggle('is-zoomed', state.zoomLevel > 1);
}

export function updateZoomUI(state: LightboxState, elements: LightboxElements): void {
    elements.zoomLevelDisplay.textContent = Math.round(state.zoomLevel * 100) + '%';
    elements.zoomIn.disabled = state.zoomLevel >= MAX_ZOOM;
    elements.zoomOut.disabled = state.zoomLevel <= MIN_ZOOM;
}
